export const trimStringToMentionFormat = (string: string, username: Array<string>) => {
    string = (string.indexOf(']') !== -1 && string[string.indexOf(']') + 1] === '(') ? string.replace(/ *\([^)]*\) */g, "") : string;
    for(let i = 0; i < username.length; i++) string = string.replace(username[i], username[i].replace('[', '').replace(']', '').concat(' '));
    return string;
}